import ServicePage from '../../components/service/ServicePage'

export default function ScreenPrinting() {
  return <ServicePage service="screen" lang="en" />
}
